import './SuggestionsInfoSection.css';
export var container = '_1pyam7v1-3-12-1';
export var shortcutLabel = '_1pyam7v3-3-12-1';
export var shortcutsGroup = '_1pyam7v2-3-12-1';